import { apiService } from './api';

export interface WarehouseProduct {
  id:   number;
  name: string;
  sku:  string;
}

const PRODUCTS_API = '/products';

export const recipeService = {
  /** Products that have stock in the given warehouse (for ingredient dropdowns). */
  getProductsByWarehouse: (warehouseId: number) =>
    apiService.get<WarehouseProduct[]>(`${PRODUCTS_API}/by-warehouse/${warehouseId}`),
};
